export default __webpack_public_path__ + "static/media/august.b9c8ca94.png";